<template>
  <div>
    <div class="Action-form Action-form--metadata">
      <div class="Grid--beta">
        <div class="Grid__col Grid__col--12 Action-form__inner">
          <!-- <div class="Action-form__top__info"> -->
          <div v-if="action.description" class="Action-form__description">
            <vue-markdown
              class="Action-form__inner__description"
              :postrender="addClasses"
              >{{ action.description }}</vue-markdown
            >
          </div>
          <!-- </div> -->
          <div class="Action-form__radiobuttons">
            <RadioInput
              :disabled="
                action.status === 'IN_REVIEW' || action.status === 'APPROVED'
              "
              text="Ja"
              :value="true"
              :checked="action.actionIsPositive"
              @input="responseSelected"
            />
            <RadioInput
              :disabled="
                action.status === 'IN_REVIEW' || action.status === 'APPROVED'
              "
              text="Nej"
              :value="false"
              :checked="action.actionIsPositive === false"
              @input="responseSelected"
            />
          </div>
          <ApplicationActionMetaGroupAffiliation
            v-if="action.type == 'GROUP_AFFILIATION'"
            :action="action"
            :isPositive="action.actionIsPositive"
            :disabled="disabled"
          />
          <ApplicationActionMetaSuppliers
            v-else-if="action.type == 'SUPPLIERS'"
            :action="action"
            :isPositive="action.actionIsPositive"
            :disabled="disabled"
          />
          <ApplicationActionMetaContact
            v-else-if="action.type == 'CONTACT'"
            :action="action"
            :isPositive="action.actionIsPositive"
            :disabled="disabled"
          />
          <ApplicationActionMetaWorkpsychologyPolicy
            v-else-if="action.type == 'WORKPSYCHOLOGY_POLICY'"
            :action="action"
            :isPositive="action.actionIsPositive"
            :disabled="disabled"
          />
          <ApplicationActionMetaEducation
            v-else
            :action="action"
            :isPositive="action.actionIsPositive"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import RadioInput from "@/components/forms/RadioInput";
import ApplicationActionMetaGroupAffiliation from "./ApplicationActionMetaGroupAffiliation";
import ApplicationActionMetaSuppliers from "./ApplicationActionMetaSuppliers";
import ApplicationActionMetaEducation from "./ApplicationActionMetaEducation";
import ApplicationActionMetaContact from "./ApplicationActionMetaContact";
import ApplicationActionMetaWorkpsychologyPolicy from "./ApplicationActionMetaWorkpsychologyPolicy";
import VueMarkdown from "vue-markdown";

export default {
  name: "ApplicationActionMeta",
  components: {
    RadioInput,
    ApplicationActionMetaWorkpsychologyPolicy,
    ApplicationActionMetaGroupAffiliation,
    ApplicationActionMetaSuppliers,
    ApplicationActionMetaEducation,
    ApplicationActionMetaContact,
    "vue-markdown": VueMarkdown
  },
  props: {
    action: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: "",
      isSubmitLoading: false
    };
  },
  computed: {
    ...mapGetters("memberStore", ["isApplicant"]),
    ...mapState("applicationStore", ["application"])
  },
  methods: {
    ...mapActions("applicationStore", [
      "updateWorkpsychologyPolicy",
      "updateGroupAffiliation",
      "updateSuppliers",
      "updateEducation",
      "updateContact"
    ]),
    approved() {
      return this.action.status === "APPROVED";
    },
    submitted() {
      return this.action.status === "IN_REVIEW";
    },
    // isDisabled () {
    //   return action.status === 'IN_REVIEW' || action.status === 'APPROVED'
    // },
    responseSelected(checked, val) {
      if (this.action.type === "GROUP_AFFILIATION") {
        this.updateGroupAffiliation({
          actionId: this.action.id,
          data: {
            actionIsPositive: val,
            companyName: "",
            organizationNumber: ""
          }
        });
      } else if (this.action.type === "SUPPLIERS") {
        this.updateSuppliers({
          actionId: this.action.id,
          data: {
            actionIsPositive: val,
            suppliers: [
              {
                sortIndex: "1",
                companyName: "",
                organizationNumber: ""
              }
            ]
          }
        });
      } else if (this.action.type === "WORKPSYCHOLOGY_POLICY") {
        this.updateWorkpsychologyPolicy({
          actionId: this.action.id,
          data: {
            actionIsPositive: val,
            attachmentUrl: "",
            attachmentFilename: ""
          }
        });
      } else {
        this.updateEducation({
          actionId: this.action.id,
          save: true,
          data: {
            actionIsPositive: val,
            hasUpcomingEducation: false,
            participants: [
              {
                sortIndex: "1",
                name: "",
                courseDate: ""
              }
            ]
          }
        });
      }
    },
    addClasses(html) {
      return html
        .replace("<h1>", '<p class="Action-form__header">')
        .replace("<h2>", '<p class="Action-form__header">');
    }
  }
};
</script>

<style lang="scss" scoped></style>
